export function extractIdFromSlug(slugParam) {
  if (!slugParam) {
    return '';
  }

  // New format: double-hyphen separator
  const doubleHyphenIndex = slugParam.indexOf('--');
  if (doubleHyphenIndex !== -1) {
    return slugParam.substring(0, doubleHyphenIndex);
  }

  // Old format fallback: first single hyphen
  const firstHyphenIndex = slugParam.indexOf('-');
  if (firstHyphenIndex === -1) {
    return slugParam;
  }

  return slugParam.substring(0, firstHyphenIndex);
}

